export default {
    methods: {
        convertSearchHeaders(search, headers = this.headers) {
            if (!search || !headers)
                return search;
            let result = search;
            // headers have to be sorted with descending header.text.length 
            // to prevent wrong replacing in cases where one header.text is included in another
            const sortedHeaders = [...headers]
                .filter((header) => header.text !== undefined)
                .map((header) => ({ text: header.text, value: header.value.replaceAll('data.', '') }))
                .sort(function (first, second) {return second.text.length - first.text.length;});
            for (const header of sortedHeaders) {
                let regex = new RegExp("(\\s|^)" + this.regexEscape(header.text) + "(?=:)", 'g');
                result = result.replaceAll(regex, ' ' + header.value)
            }
            return result;
        },
        regexEscape(text) {
            return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
        }
    }
}